<template>

  <div id="pop-login">
    <van-popup v-model="showLogin" :close-on-click-overlay="true" round
      :style="{width:'90%',overflow:'visible',borderRadius:'10px'}">
      <div class="pop-login">
        <div class="logo"></div>
        <div class="content">
          <div class="input-box">
            <span>手机号</span>
            <input class="phone" placeholder="请输入手机号" v-model="phone" maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')" />
          </div>
          <div class="input-box">
            <span>密码</span>
            <input class="password" placeholder="请输入密码" v-model="password" type="password" maxlength="16" />
          </div>
          <button id="loginbtn" class="loginbtn" :style="{backgroundColor:activeColor}" @click="loginClick">登录</button>
          <div class="register">
            <div class="image"></div>
            <div class="left" @click="bottomClick(2)">立即注册</div>
            <div class="right" @click="bottomClick(3)">忘记密码？</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

// 引入
import { Toast } from 'mint-ui'

export default {
  props: {
    show: false
  },
  data () {
    return {
      showLogin: this.show,
      phone: '',
      password: '',
      code: '',
      activeColor: '#fecdcd'
    }
  },
  methods: {
    bottomClick: function (index) {
      // 0 隐藏 1 登录成功 2 注册 3 忘记密码
      this.$emit('click', index)
    },
    checkParam: function () {
      if (this.utils.isNull(this.phone)) {
        Toast('请输入手机号！')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入手机号！')
        return false
      }
      if (this.utils.isNull(this.password)) {
        Toast('请输入密码！')
        return false
      }
      return true
    },
    loginClick: function () {
      if (this.checkParam() === false) {
        return
      }
      let param = {
        'account': this.phone,
        'password': this.password
      }
      var _this = this

      this.utils.POST(this.accountUrl + '/account/login', param, function (data) {
        _this.getInfo()
        localStorage.removeItem('openId')
      })
    },
    getInfo: function () {
      localStorage.setItem('isLogin', 1)
      var _this = this
      this.utils.GET(this.companyUrl + '/ent/json',
        function (data) {
          localStorage.setItem('userinfo', JSON.stringify(data.data))
          setTimeout(()=>{
           location.reload()
          },500)
          _this.$emit('click', 1)
        })
    }
  },
  watch: {
    show (val) {
      this.showLogin = val
    },
    showLogin (val) {
      if (val === false) {
        this.$emit('click', 0)
      }
    },
    phone: function (val) {
      if (val > 11) {
        this.phone = val.slice(0, 11)
      }
      this.activeColor = '#fecdcd'
      if (this.phone.length > 0 && this.password.length > 0) {
        this.activeColor = '#c41335'
      }
    },
    password: function (val) {
      this.activeColor = '#fecdcd'
      if (this.phone.length > 0 && this.password.length > 0) {
        this.activeColor = '#c41335'
      }
    }
  },
  mounted () {
    // console.log(this)
    // console.log(this.$router.history)
    // console.log(window.history.length)
  }
}
</script>

<style scoped>
.pop-login {
  /*position: absolute;*/
  /*width: calc(100% - 30px);*/
  /*height: 350px;*/
  background-color: yellow;
}
.van-popup {
  height: 305px;
}
.pop-login .logo {
  position: absolute;
  top: -50px;
  left: calc(50% - 55px);
  width: 110px;
  height: 94px;
  background-image: url("../../../assets/icon-logo.png");
  background-size: cover;
  background-position: center center;
  z-index: 100;
}
.pop-login .content {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  background-color: #ffffff;
}
.content .input-box {
  position: relative;
  top: 30px;
  left: 20px;
  width: calc(100% - 40px);
  height: 54px;
  line-height: 54px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
  /*background-color: yellow;*/
}
.content .input-box span {
  position: absolute;
  font-size: 15px;
  color: #000000;
  top: 20px;
  height: 15px;
  line-height: 15px;
}
.content .input-box input {
  position: absolute;
  left: 70px;
  height: 53px;
  width: calc(100% - 70px);
  line-height: 53px;
  font-size: 15px;
  color: #000000;
  border: none;
  padding: 15px 0;
  line-height: 24px;
  /*background-color: pink;*/
}
.content .loginbtn {
  position: relative;
  top: 50px;
  left: 20px;
  width: calc(100% - 40px);
  height: 40px;
  line-height: 40px;
  background-color: #fecdcd;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  border-radius: 4px;
}
.content .register {
  position: relative;
  top: 65px;
  left: 20px;
  width: calc(100% - 40px);
  height: 15px;
  /*background-color: yellow;*/
}
.content .register .image {
  position: absolute;
  top: 3px;
  left: 1px;
  width: 9px;
  height: 8px;
  background-image: url("../../../assets/icon-arrow-red.png");
  background-size: cover;
  background-position: center;
}
.content .register .left {
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 15px;
  height: 15px;
  font-size: 12px;
  color: #c41335;
  line-height: 15px;
}
.content .register .right {
  display: inline-block;
  position: absolute;
  top: 0px;
  right: 0px;
  height: 15px;
  font-size: 12px;
  color: #999999;
  line-height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/pop-login.vue